import http from '../../utils/fetch';
export default {
    baseurl:'/api/swyl/v1/mubiao',
    baseurl2:'/api/swyl/v1',

    //目标列表
    page(query){
        return http({
            url: this.baseurl+'/userDailyTarget/newSelectPage',
            method: 'post',
            params: query
        });
    },

    getDeptList(query){
        return http({
            url: this.baseurl+'/userDailyTarget/selectDept',
            method: 'post',
            params: query
        });
    },
    getQuyuList(query){
        return http({
            url: this.baseurl+'/userDailyTarget/selectarea',
            method: 'post',
            params: query
        });
    },

    getWeekList(query){
        return http({
            url: this.baseurl+'/userDailyTarget/getWeekList',
            method: 'post',
            params: query
        });
    },
    saveOrUpdate(query){
        return http({
            url: this.baseurl+'/userDailyTarget/saveOrUpdate',
            method: 'post',
            data: query
        });
    },
    selectById(query){
        return http({
            url: this.baseurl+'/userDailyTarget/selectById',
            method: 'post',
            params: query
        });
    },
    getClearPlanById(query){
        return http({
            url: this.baseurl+'/userDailyTarget/getClearPlanById',
            method: 'post',
            params: query
        });
    },

    del(query){
        return http({
            url: this.baseurl+'/userDailyTarget/deleteById',
            method: 'post',
            params: query
        });
    },
    tzGrade(query){
        return http({
            url: this.baseurl+'/userDailyTarget/tzGrade',
            method: 'post',
            data: query
        });
    },
    getProject(query){
        return http({
            ///api/swyl/v1/mubiao/userDailyTargetProject/selectProList?projectName=
            url: this.baseurl+'/userDailyTargetProject/selectProList?projectName=',
            method: 'post',
            data: query
        });
    },
    getUser(query){
        return http({
            ///api/swyl/v1/mubiao/userDailyTargetProject/selectProList?projectName=
            url: this.baseurl2+'/dailyClear/userDailyClear/getCustomer?userName=' + query,
            method: 'post',
            //data: query
        });
    },
    getcust(query){
        return http({
            url: '/api/swyl/v1/dailyClear/userDailyClear/getCust' ,
            method: 'post',
            data: query
        });
    },
    getUserLoud(query){
        return http({
            ///api/swyl/v1/mubiao/userDailyTargetProject/selectProList?projectName=
            url: this.baseurl2+'/dailyClear/userDailyClear/getCustomerLoud?userName=' + query,
            method: 'post',
            //data: query
        });
    },

    //--------------------------日计划部分--------------------
    selectPage(query){
        return http({
            ///api/swyl/v1/mubiao/userDailyTargetProject/selectProList?projectName=
            url: this.baseurl2+'/dailyClear/userDailyClear/selectPage',
            method: 'post',
            params: query
        });
    },
    checkPage(query){
        return http({
            ///api/swyl/v1/mubiao/userDailyTargetProject/selectProList?projectName=
            url: this.baseurl2+'/dailyClear/userDailyClear/checkPage',
            method: 'post',
            params: query
        });
    },
    getDayClearPlan(query){
        return http({
            url: this.baseurl2+'/dailyClear/userDailyClear/getDayClearPlanPage',
            method: 'post',
            params: query
        });
    },

    getClearAppraisal(query){
        return http({
            url: this.baseurl2+'/guanhuai/userDailyClearAppraisal/selectPage',
            method: 'post',
            params: query
        });
    },

    delById(query){
        return http({
            url: this.baseurl2+'/dailyClear/userDailyClear/delById?id=' + query,
            method: 'post',
            //data: query
        });
    },
    // 删除
    deleteById(query){
        return http({
            url: this.baseurl2+'/guanhuai/bscClueManage/deleteById?id=' + query,
            method: 'post',
            //data: query
        });
    },
    // 批量删除
    deletebatchById(query){
        return http({
            url: this.baseurl2+'/guanhuai/bscClueManage/deletebatchById',
            method: 'post',
            data: query
        });
    },
    // 物理删除
    wulideleteById(query){
        return http({
            url: this.baseurl2+'/guanhuai/bscClueManage/wulideleteById',
            method: 'post',
            data: query
        });
    },

    //删除线索跟踪记录
    deletecluetrack(query){
        return http({
            url: this.baseurl2+'/guanhuai/bscClueTrack/delete?id=' + query,
            method: 'post',
            //data: query
        });
    },
    //批量导入线索管理
    exportBscClueManage(query){
        return http({
            url: this.baseurl2+'/guanhuai/bscClueManage/exportBscClueManage',
            method: 'post',
            data: query
        });
    },

    checkPunchPage(query){
        return http({
            url: this.baseurl2+'/dailyClear/userDailyClear/checkPunchPage',
            method: 'post',
            params: query
        });
    },

    canDailyClear(query){
        return http({
            url: this.baseurl2+'/dailyClear/userDailyClear/canDailyClear',
            method: 'post',
            params: query
        });
    },


    getListPlan(query){
        return http({
            url: this.baseurl+'/userDailyTarget/selectDetailList',
            method: 'post',
            params: query
        });
    },
    insertAll(query){
        return http({
            url: this.baseurl2+'/dailyClear/userDailyClear/insertAll',
            method: 'post',
            data: query
        });
    },
    //指派
    designatecommit(query){
        return http({
            url: this.baseurl2+'/guanhuai/bscClueManage/designate',
            method: 'post',
            data: query
        });
    },
    //联系人插入
    insertbcp(query){
        return http({
            //  /api/swyl/v1/guanhuai/bscContactPerson
            url: this.baseurl2+'/guanhuai/bscClueManage/saveOrUpdate',
            method: 'post',
            data: query
        });
    },
    //线索追踪添加
    insertcluetrack(query){
        return http({
            url: this.baseurl2+'/guanhuai/bscClueTrack/saveOrUpdate',
            method: 'post',
            data: query
        });
    },
    //单个查询
    getDailyPlanSingle(query){
        return http({
            url: this.baseurl2+'/dailyClear/userDailyClear/getDailyPlan?id=' + query,
            method: 'post',
            //data: query
        });
    },
    //联系人修改查询单个
    getbscConcactpersonSingle(query){
        return http({
            url: this.baseurl2+'/guanhuai/bscContactPerson/selectById?id=' + query,
            method: 'post',
            //data: query
        });
    },

    selectClue(query){
        return http({
            url: this.baseurl2+'/guanhuai/bscClueTrack/selectList',
            method: 'post',
            data: query
        });
    },
    selectCluepress(query){
        return http({
            url: this.baseurl2+'/guanhuai/bscClueManage/selectPressList',
            method: 'post',
            params: query
        });
    },
    getBsccone(query){
        return http({
            url: this.baseurl2+'/guanhuai/bscContactPerson/selectById?id=' + query,
            method: 'post',
            //data: query
        });
    },

    //修改提交
    updateById(query){
        return http({
            url: this.baseurl2+'/dailyClear/userDailyClear/updateById',
            method: 'post',
            data: query
        });
    },
    //url:'api/swyl/v1/dailyClear/userDailyClear/updateById',
    //url:'/api/swyl/v1/dailyClear/userDailyClear/getDailyPlan?id='+ id,
    //url:'/api/swyl/v1/dailyClear/userDailyClear/delById?id='+ id ,
    //目标列表
    pageCK(query){
        return http({
            url: this.baseurl+'/userDailyTarget/newSelectCKPage',
            method: 'post',
            params: query
        });
    },
    saveOrUpdateCk(query){
        return http({
            url: this.baseurl+'/userDailyTarget/saveOrUpdateCk',
            method: 'post',
            params: query
        });
    },
    submitDaily(query){
        return http({
            url: this.baseurl2+'/dailyClear/userDailyClear/submitDaily',
            method: 'post',
            data: query
        });
    },

    //网络对阵




    //周计划汇总查询
    getColletWeek(query){
        return http({
            url: '/api/swyl/v1/mubiao/userDailyTargetCollect/getCollectPage',
            method: 'post',
            params: query
        });
    },

    //周目标明细
    getSummaryWeek(query){
        return http({
            url: '/api/swyl/v1/mubiao/userDailyTargetSummary/getSummaryPage',
            method: 'post',
            params: query
        });
    },
    getWsDifference(query){
        return http({
            url: '/api/swyl/v1/mubiao/userResDistinction/selectResDistinctionPage',
            method: 'post',
            params: query,
        })
    },

    //线索管理查询
    searchGonhaoBscClue(query){
        return http({
            url: '/api/swyl/v1/guanhuai/bscClueManage/searchGonhaoBscCluePage',
            method: 'post',
            params: query,
        })
    },

    //线索管理查询
    getBscClueManage(query){
        return http({
            url: '/api/swyl/v1/guanhuai/bscClueManage/selectAllClueManagePage',
            method: 'post',
            params: query,
        })
    },

    //线索统计表查询
    getBscClueReport(query) {
        return http({
            url: '/api/swyl/v1/guanhuai/bscClueManage/selectClueReportPage',
            method: 'post',
            params: query,
        })
    },

    downloadBatchExcelSummary(query) {
        return http({
            url: '/api/swyl/v1/mubiao/userDailyTargetSummary/downloadExcel',
            method: 'post',
            data: query,
            responseType: 'blob',
            dataType:"json",
        });
    },
    //周目标管理导出详情
    downloadBatchExcelMubiaoWeek(query) {
        return http({
            url: '/api/swyl/v1/mubiao/userDailyTarget/downloadExcelTy',
            method: 'post',
            data: query,
            responseType: 'blob',
        });
    },
    //查询导入列表
    selecttoLeadPage(data){
        return http({
            url: '/api/swyl/v1/guanhuai/bscClueManage/selecttoLeadPage',
            method: 'post',
            params: data
        })
    },

    //导入列表确定
    ImportListDetermination(data){
        return http({
            url: '/api/swyl/v1/guanhuai/bscClueManage/ImportListDetermination',
            method: 'post',
            data: data
        })
    },
    //导入列表取消
    ImportListCancellation(data){
        return http({
            url: '/api/swyl/v1/guanhuai/bscClueManage/ImportListCancellation',
            method: 'post',
            params: data
        })
    },

    //线索来源查询
    selectCluesPage(query){
        return http({
            url: '/api/swyl/v1/guanhuai/bscCluesResource/selectPage',
            method: 'post',
            params: query,
        })
    },
    //新增线索来源
    insertCluesResource(query){
        return http({
            url: '/api/swyl/v1/guanhuai/bscCluesResource/insert',
            method: 'post',
            params: query
        });
    },
    //线索来源状态更新
    updateStatus(query){
        return http({
            url: '/api/swyl/v1/guanhuai/bscCluesResource/updateStatus',
            method: 'post',
            params: query
        });
    },
    //获取线索来源
    getClueResource(query){
        return http({
            url: '/api/swyl/v1/guanhuai/bscCluesResource/getResourceList',
            method: 'post',
            params: query
        });
    },
    //获取线索来源
    createClueBarcode(query){
        return http({
            url: '/api/swyl/v1/guanhuai/bscCluesResource/createClueBarcode',
            method: 'post',
            params: query,
            responseType:'blob',  //加上这一行
        });
    },
    // 根据对象获取实体
    getXsTelephone(query){
        return http({
            url: '/api/swyl/v1/guanhuai/bscClueManage/getXsTelephone?telephone='+query,
            method: 'post',
        });
    },

    getById(query){
        return http({
            url: '/api/swyl/v1/guanhuai/bscClueManage/getById?id=' + query,
            method: 'post',
        });
    },

    //指派
    designate(query){
        return http({
            url: '/api/swyl/v1/guanhuai/bscClueManage/designate',
            method: 'post',
            data: query
        });
    },
    //承接
    undertake(query){
        return http({
            url: '/api/swyl/v1/guanhuai/bscClueManage/undertake',
            method: 'post',
            params: query
        });
    },

}
